import { useCallback } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { getIsUserSignedIn } from "@gamedev-web/gamedev-sdk-core";

import { xboxOnboardSiteLocationPrefix } from "../../constants";

export const usePartnerLandingEntryNavigation = () => {
  const history = useHistory();
  const isSignedIn = useSelector(getIsUserSignedIn);

  return useCallback(() => {
    history.push(`${xboxOnboardSiteLocationPrefix}/${isSignedIn ? "new" : "signup"}`);
  }, [history, isSignedIn]);
};
